import * as React from "react";
import { Sections } from "../../components/Home";
import { useMatchesSmDown, useMatchesXsDown } from "../../hooks";
import css from "./Home.module.css";

export default function Home() {
  const isMobile = useMatchesXsDown();
  const isSmall = useMatchesSmDown();

  return (
    <>
      <Sections.Hero isMobile={isSmall} />

      <div className={css.container}>
        <Sections.Main isMobile={isMobile} />
      </div>
    </>
  );
}
